import { Grid, Skeleton, Typography } from "@mui/material";
import { BrandsContext } from "contexts/Brands";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { forwardRef, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { BentoBrand, SearchParams } from "schemas/dashboard";

import DiscoverCard from "../../DiscoverCard";
import styles from "../styles";

const REF_INDEX = 9; // The index used to start loading more recommendations

interface Props {
  brandsLoading: boolean;
  fetchMoreLoading: boolean;
}

export default forwardRef<HTMLDivElement, Props>(
  ({ brandsLoading, fetchMoreLoading }, ref) => {
    const [searchParams] = useSearchParams();
    const { discoverTab } = useContext(DiscoverViewContext);
    const brandQuery = searchParams.get(SearchParams.QUERY_DISCOVER);
    const isSearching = brandQuery && brandQuery?.length > 0;

    const { similarBrands } = useContext(BrandsContext);

    return (
      <Grid item container sx={{ mt: 2, width: "100%" }}>
        {similarBrands.length > 0 && (
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={styles.searchingText}
              gutterBottom
              textAlign="left"
            >
              {isSearching ? `Similar to "${brandQuery}"` : "Similar Brands"}
            </Typography>
          </Grid>
        )}

        <Grid container item xs={12} rowGap={1} columnSpacing={1}>
          {similarBrands?.map((brand: BentoBrand, idx: number) => (
            <Grid
              item
              xs={12}
              md={12}
              lg={discoverTab === null ? 6 : 12}
              xl={6}
              key={`brand-card-similar-${brand.id}-${idx}`}
            >
              <DiscoverCard
                ref={
                  (
                    similarBrands.length > REF_INDEX
                      ? idx === similarBrands.length - REF_INDEX
                      : idx === similarBrands.length - 1
                  )
                    ? ref
                    : undefined
                }
                brand={brand}
              />
            </Grid>
          ))}
        </Grid>

        {!brandsLoading && similarBrands.length > 0 && fetchMoreLoading && (
          <Grid container justifyContent={"center"} sx={{ mt: 2 }}>
            {Array.from({ length: 3 }, (x, i) => (
              <Skeleton
                key={i}
                variant="rounded"
                width={"100%"}
                height={100}
                sx={{ mb: 2 }}
              />
            ))}
          </Grid>
        )}
      </Grid>
    );
  },
);
